var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32084_4574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 38C29.9934 38 38.5 29.4934 38.5 19C38.5 8.50659 29.9934 0 19.5 0C9.00659 0 0.5 8.50659 0.5 19C0.5 29.4934 9.00659 38 19.5 38Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19407 18.5884L27.5132 11.5252C28.3635 11.218 29.1061 11.7326 28.8306 13.0183L28.8322 13.0167L25.713 27.7116C25.4818 28.7534 24.8627 29.0068 23.9967 28.5159L19.2467 25.0152L16.9556 27.2223C16.7022 27.4757 16.4885 27.6894 15.9977 27.6894L16.3349 22.8555L25.1382 14.9024C25.5214 14.5652 25.0527 14.3752 24.5477 14.7108L13.6686 21.5603L8.97874 20.0973C7.96065 19.7743 7.93849 19.0793 9.19407 18.5884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32084_4574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.36798ce2e322413c279bbf8a27b521f0.svg";
export { ForwardRef as ReactComponent };